import http from './http';

export interface AuthExchangeResponse {
  id: number;
  email: string;
}

/**
 * Exchange Auth0 tokens for a Spring Session.
 * After this call the browser has a SESSION cookie — no Bearer needed.
 */
export async function auth0Exchange(
  accessToken: string,
  idToken: string
): Promise<AuthExchangeResponse> {
  const res = await http.post<AuthExchangeResponse>(
    '/auth/auth0/exchange',
    { accessToken, idToken },
    {
      headers: { Authorization: `Bearer ${accessToken}` },
      withCredentials: true,
    }
  );
  return res.data;
}

/**
 * Sign up a new user using Auth0 tokens.
 * Called when auth0Exchange returns 401 (user not found in DB).
 */
export async function auth0SignUp(
  accessToken: string,
  idToken: string
): Promise<unknown> {
  const res = await http.post(
    '/v1/auth/sign_up/',
    {
      access_token: accessToken,
      id_token: idToken,
      agree_with_LTD_Terms_of_use_Privacy_policy_Acceptable_use_policy: true,
    },
    { withCredentials: true }
  );
  return res.data;
}

/**
 * Get current user from Spring Session.
 */
export async function getSessionUser() {
  const res = await http.get('/auth/get_user', { withCredentials: true });
  return res.data;
}

/**
 * Logout — invalidate Spring Session.
 */
export async function logout() {
  await http.post('/auth/logout', {}, { withCredentials: true });
}
